import dayIcon from '../assets/new-ui/day-icon.svg'
import heartIcon from '../assets/new-ui/myNFT/heart-icon.svg'
import heartIconPink from '../assets/new-ui/myNFT/heart-icon-red.svg'
import bnbIcon from '../assets/new-ui/bnb-icon.png'
import { 
  RARITY_NORMAL,
  RARITY_UNCOMMON,
  RARITY_RARE,
  RARITY_EPIC,
  RARITY_LEGENDARY,
  RARITY_MYTHIC,
  RARITY_UNIQUE,
  RARITY_DEMI_GOD,
  RARITY_GOD 
} from '../constants/config'
import { useState, useEffect } from 'react'

export default function ItemSell(props) {
  const {image, id, rarityPoint, rarityClass, price, unit, likeNumber, isLiked, timestamp, fn, likeFn} = props
  const [delay, setDelay] = useState(false)

  useEffect(() => {
    if (delay) {
      let timeout = setTimeout(() => {
        setDelay(false)
      }, 2000)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [delay])

  function likeNFT() {
    if (!delay) {
      likeFn()
      setDelay(true)
    }
  }

  function calcRankingClass(ranking) {
    switch (ranking) {
      case RARITY_NORMAL:
        return 'rankedC'
      case RARITY_UNCOMMON:
        return 'rankedB'
      case RARITY_RARE:
        return 'rankedB'
      case RARITY_EPIC:
        return 'rankedA'
      case RARITY_LEGENDARY:
        return 'rankedA'
      case RARITY_MYTHIC:
        return 'rankedS'
      case RARITY_UNIQUE:
        return 'rankedS'
      case RARITY_DEMI_GOD:
        return 'rankedGod'
      case RARITY_GOD:
        return 'rankedGod'
      default: return 'rankedC'
    }
  }

  function getTimeSell(timestamp) {
    const aDay = 24 * 60 * 60 * 1000
    const aWeek = 7 * aDay
    const currentTime = new Date().getTime()
    const sellTime = new Date(timestamp).getTime()
    if (currentTime - sellTime <= aDay) return 'recently'
    else if (currentTime - sellTime > aDay && currentTime - sellTime <= aWeek) return 'a few days ago'
    else return 'a few weeks ago'
  }

  return (
    <div className='itemSell'>
      <div className='itemImg' onClick={() => fn()}>
        <img src={image} alt='' />
      </div>

      <div className='itemInfoContainer'>
        <div className='itemInfo'>
          <div className='itemDetail'>
            <div className='itemIdTitle'>NFT Id</div>
            <div className='itemId'>{id}</div>
          </div>
          <div className='itemDetail'>
            <div>Rarity Point</div>
            <div className='itemPercent'>{rarityPoint}</div>
          </div>
          <div className='itemDetail'>
            <div>Rarity Class</div>
            <div className={'rankedClass ' + calcRankingClass(rarityClass)}>{rarityClass}</div>
          </div>
        </div>
        <div className='itemPrice'>
          <div><img src={bnbIcon} alt='' /> <div className='priceTitle'>Price</div></div>
          <div className='priceValue'> {price + ' ' + unit}</div>
        </div>
      </div>
      

      <div className='itemMore'>
        <div className='itemDay'>
          <img src={dayIcon} alt='' />
          <div>{getTimeSell(timestamp)}</div>
        </div>
        <div className='itemLike'>
          <img src={isLiked ? heartIconPink : heartIcon} alt='' onClick={() => likeNFT()}/>
          <div>{likeNumber ? likeNumber : 0}</div>
        </div>
      </div>
      
    </div>
  )
}